import React, { FC, ReactNode } from "react";
import { I18n, OnI18nErrorFn } from "@lookiero/i18n-react";
import { Kameleoon } from "@lookiero/sty-psp-ab-testing";
import { Locale } from "@lookiero/sty-psp-locale";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Customer } from "../../../../projection/customer/customer";
import { KameleoonEnvironment } from "../../../ab-testing/kameleoonEnvironment";
import { StaticInfoProvider } from "../../hooks/useStaticInfo";

interface NextBestActionProvidersComponentProps {
  readonly customer: Customer;
  readonly locale: Locale;
  readonly children: ReactNode;
  readonly tradename: Tradename;
}

type NextBestActionProvidersComponent = FC<NextBestActionProvidersComponentProps>;

interface NextBestActionProvidersFunctionArgs {
  readonly I18n: I18n;
  readonly kameleoon: KameleoonEnvironment;
  readonly onI18nError: OnI18nErrorFn;
  readonly apiUrl: () => string;
  readonly getAuthToken: () => Promise<string>;
  readonly androidInAppBrowser?: boolean;
}

interface NextBestActionProvidersFunction {
  (args: NextBestActionProvidersFunctionArgs): NextBestActionProvidersComponent;
}

const nextBestActionProviders: NextBestActionProvidersFunction =
  ({ I18n, apiUrl, getAuthToken, kameleoon, onI18nError, androidInAppBrowser }) =>
  ({ customer, locale, children, tradename }) => (
    <StaticInfoProvider
      androidInAppBrowser={androidInAppBrowser}
      apiUrl={apiUrl}
      basePath="" // In this context its not required
      customer={customer}
      getAuthToken={getAuthToken}
      kameleoon={kameleoon}
      tradename={tradename}
    >
      <Kameleoon consented={kameleoon.consented} experiments={kameleoon.experiments} siteCode={kameleoon.siteCode}>
        <I18n loader={<></>} locale={locale} onError={onI18nError}>
          {children}
        </I18n>
      </Kameleoon>
    </StaticInfoProvider>
  );

export { nextBestActionProviders };
